import { render, staticRenderFns } from "./ingredient.vue?vue&type=template&id=49337fe0&scoped=true&"
import script from "./ingredient.vue?vue&type=script&lang=js&"
export * from "./ingredient.vue?vue&type=script&lang=js&"
import style0 from "./ingredient.vue?vue&type=style&index=0&id=49337fe0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49337fe0",
  null
  
)

export default component.exports